<template>
  <div v-if="viewdata.type === 'accesschange' || viewdata.type === 'bulkaccesschange'">
    <!-- <v-chip class="noTransform ru-info-chip gap-2 align-center mb-4">
      <span><v-icon>mdi-information-outline</v-icon> New users will be added/removed inline with the information provided below.</span>
    </v-chip> -->
    
    <div class="d-flex flex-column gap-3">
      <v-row no-gutters class="align-center">
        <v-col cols="12" sm="3" class="details-label">
          Selected {{$nova.labelsName('approvals_page','ru_entity_plural_label','RUs')}}
        </v-col>
        <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
          <div 
            class=""
            v-for="(v,k) in viewdata.reportingunit_detail" 
            :key="k"
          >
            <v-chip label class="RU-Chip"><span class="noTransform RU-Chip-Text">{{v.code}} - {{v.name}}</span></v-chip>
          </div>
        </v-col>
      </v-row>

      <div v-if="viewdata.data[0]?.adduser" class="mt-2">
        <v-row>
          <v-col cols="12" sm="3">
            <div class="">
              <span class="font-weight-bold border-left-success">Add Users</span>
            </div>
          </v-col>
          <v-col cols="12" sm="9">
            <v-row v-if="(viewdata.data[0].adduser?.submitter || []).length > 0" no-gutters class="flex-column gap-2">
              <v-col cols="12" sm="3" class="details-label">
                {{ $nova.labelsName('approvals_page','commentary_local_preparer_label','Local Preparer') }}(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.submitter || [])" :key="k">
                  <span class="details-value">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row v-if="(viewdata.data[0].adduser?.approver || []).length > 0" no-gutters class="flex-column gap-2">
              <v-col cols="12" sm="3" class="details-label">
                {{ $nova.labelsName('approvals_page','commentary_local_approver_label','Local Approver') }}(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.approver || [])" :key="k">
                  <span class="details-value">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row v-if="(viewdata.data[0].adduser?.manager || []).length > 0" no-gutters class="flex-column gap-2">
              <v-col cols="12" sm="3" class="details-label">
                Manager(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.manager || [])" :key="k">
                  <span class="details-value">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row v-if="(viewdata.data[0].adduser?.regional_approver || []).length > 0" no-gutters class="flex-column gap-2">
              <v-col cols="12" sm="3" class="details-label">
                {{$nova.labelsName('approvals_page','commentary_regional_approver_label','Regional Approver')}}(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.regional_approver || [])" :key="k">
                  <span class="details-value">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div v-if="viewdata.data[0]?.removeuser" class="mt-2">
        <v-row>
          <v-col cols="12" sm="3">
            <div class="">
              <span class="font-weight-bold border-left-error">Remove Users</span>
            </div>
          </v-col>
          <v-col cols="12" sm="9" class="d-flex flex-column gap-3">
            <v-row v-if="(viewdata.data[0].removeuser?.submitter || []).length > 0" no-gutters class="flex-column gap-2 flex-nowrap">
              <v-col cols="12" sm="3" class="details-label">
                {{$nova.labelsName('approvals_page','commentary_local_preparer_label','Local Preparer')}}(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip  class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.submitter || [])" :key="k">
                  <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row v-if="(viewdata.data[0].removeuser?.approver || []).length > 0" no-gutters class="flex-column gap-2 flex-nowrap">
              <v-col cols="12" sm="3" class="details-label">
                {{ $nova.labelsName('approvals_page','commentary_local_approver_label','Local Approver') }}(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.approver || [])" :key="k">
                  <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row v-if="(viewdata.data[0].removeuser?.manager || []).length > 0" no-gutters class="flex-column gap-2 flex-nowrap">
              <v-col cols="12" sm="3" class="details-label">
                Manager(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.manager || [])" :key="k">
                  <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row v-if="(viewdata.data[0].removeuser?.regional_approver || []).length > 0" no-gutters class="flex-column gap-2 flex-nowrap">
              <v-col cols="12" sm="3" class="details-label">
                {{ $nova.labelsName('approvals_page','commentary_regional_approver_label','Regional Approver') }}(s)
              </v-col>
              <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.regional_approver || [])" :key="k">
                  <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalAccessChange',
  props: {
    viewdata: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.border-left-success {
  color: var(--status-green);
}
.border-left-error {
  color: var(--status-red);
}


</style>
